'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Main } from './components/Main';
import { NewsShowProvider } from './contexts/NewsShowContext';
export const NewsShowView = ({ children, config, data, flags, handlers, }) => (_jsx(NewsShowProvider, { config: config, data: data, flags: flags, handlers: handlers, children: _jsx(Main, { children: children }) }));
//# sourceMappingURL=NewsShowView.js.map